<template>
  <a-drawer
    placement="right"
    width="1200"
    :closable="false"
    :visible="visible"
    @close="onClose"
  >
    <div slot="title">
      <span>账单详情</span>
    </div>
    <div v-if="loading" style="text-align:center"><a-spin/></div>
    <div style="margin-left:15px" v-if="!loading">
      <a-divider orientation="left">账单信息</a-divider>
      <detail-list size="small" :col="3">
        <detail-list-item term="账单周期">{{ viewDetailData.start_time }} ～ {{ viewDetailData.end_time }}</detail-list-item>
        <!-- <detail-list-item term="老师账号">{{ viewDetailData.teacher_account}}</detail-list-item>
        <detail-list-item term="英文名">{{ viewDetailData.teacher_name}}</detail-list-item> -->
        <detail-list-item term="正式课数">{{ viewDetailData.formal_class_count }}</detail-list-item>
        <detail-list-item term="体验课数">{{ viewDetailData.trial_class_count }}</detail-list-item>
        <detail-list-item term="订单数">{{ viewDetailData.order_count }}</detail-list-item>
        <detail-list-item term="复购量">{{ viewDetailData.order_paynum_count }}</detail-list-item>
        <detail-list-item term="老师得分">{{ viewDetailData.teacher_point_count }}</detail-list-item>
        <detail-list-item term="得分率">{{ viewDetailData.point_rate }}</detail-list-item>
        <detail-list-item term="复购率">{{ viewDetailData.repurchase_rate }}</detail-list-item>
        <detail-list-item term="订单奖金">{{ viewDetailData.order_money }}</detail-list-item>
        <detail-list-item term="课程工资">{{ viewDetailData.course_money }}</detail-list-item>
        <detail-list-item term="延时扣款">{{ viewDetailData.deduct_money }}</detail-list-item>
        <detail-list-item term="其他奖励">{{ viewDetailData.reaward_money || '--' }}</detail-list-item>
        <detail-list-item term="工资合计">{{ viewDetailData.total_money }}</detail-list-item>
        <detail-list-item term="生成时间">{{ viewDetailData.create_time || '--' }}</detail-list-item>
        <detail-list-item term="账单状态">{{ viewDetailData.status | valInDict(dict.statusDict) }}</detail-list-item>
      </detail-list>
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="订单奖金">
          <a-card :bordered="false" style="margin-left:-30px;">
            <!-- 表格筛选 start -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @submit="handleSubmit">
                <a-row :gutter="48">
                  <!-- 输入关键词查找 -->
                  <a-col :md="8" :sm="24">
                    <a-form-item label="课程名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入课程名称查询" v-model="queryParam.cname"></a-input>
                    </a-form-item>
                  </a-col>
                  <template v-if="advanced">
                  </template>
                  <!-- 展开或者收起筛选项 start -->
                  <a-col :md="!advanced && 12 || 24" :sm="24">
                    <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                      <a-button type="primary" htmlType="submit">查询</a-button>
                      <span style="margin-left:20px; font-weight:bold">奖金总计：{{ awardMoney }}</span>
                      <!-- <a-button style="margin-left: 8px" @click="reset">重置</a-button> -->
                    </span>
                  </a-col>
                  <!-- 展开或者收起筛选项 end -->
                </a-row>
              </a-form>
            </div>
            <!-- 表格筛选 end -->
            <!-- 表格内容操作 start -->
            <div class="table-operator">
            </div>
            <!-- 表格内容操作 end -->
            <!-- 表格 start -->
            <tcg-table
              style="margin-top:10px;"
              ref="orderTable"
              size="default"
              rowKey="order_id"
              :columns="columns"
              :data="loadData"
              bordered
            >
            </tcg-table>
            <!-- 表格 end -->
          </a-card>
        </a-tab-pane>
        <a-tab-pane key="2" tab="课程工资" force-render>
          <a-card :bordered="false" style="margin-left:-30px;">
            <!-- 表格筛选 start -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @submit="handleSubmit1">
                <a-row :gutter="48">
                  <!-- 输入关键词查找 -->
                  <a-col :md="8" :sm="24">
                    <a-form-item label="课程名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入课程名称查询" v-model="queryParam1.cname"></a-input>
                    </a-form-item>
                  </a-col>
                  <template v-if="advanced">
                  </template>
                  <!-- 展开或者收起筛选项 start -->
                  <a-col :md="!advanced && 12 || 24" :sm="24">
                    <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                      <a-button type="primary" htmlType="submit">查询</a-button>
                      <span style="margin-left:20px; font-weight:bold">工资总计：{{ courseMoney }} <span style="margin-left: 20px;">延时扣款：{{ deductMoney }}</span></span>
                      <!-- <a-button style="margin-left: 8px" @click="reset">重置</a-button> -->
                    </span>
                  </a-col>
                  <!-- 展开或者收起筛选项 end -->
                </a-row>
              </a-form>
            </div>
            <!-- 表格筛选 end -->
            <!-- 表格内容操作 start -->
            <div class="table-operator">
            </div>
            <!-- 表格内容操作 end -->
            <!-- 表格 start -->
            <tcg-table
              style="margin-top:10px;"
              ref="subTable"
              size="default"
              rowKey="sub_id"
              :columns="columns1"
              :data="loadData1"
              bordered
            >
              <span slot="status" slot-scope="text, record">
                <span v-if="text === 0">已取消</span>
                <span v-if="text === 1 && record.ctype !== '作文'">待上课</span>
                <span v-if="text === 1 && record.ctype === '作文'">未回稿</span>
                <span v-if="text === 2 && record.ctype !== '作文'">未上传</span>
                <span v-if="text === 2 && record.ctype === '作文'">已签收</span>
                <span v-if="text === 3 && record.ctype !== '作文'">已上传</span>
                <span v-if="text === 3 && record.ctype === '作文'">已回稿</span>
                <span v-if="text === 4">已完成</span>
              </span>
            </tcg-table>
            <!-- 表格 end -->
          </a-card>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-drawer>
</template>
<script>
import { getPre, getDetail, orderList, subscribeList } from '@/api/bill'
import _ from 'lodash'
import { TcgTable } from '@/components'
import DetailList from '@/components/DescriptionList'
const DetailListItem = DetailList.Item
export default {
  components: {
    DetailListItem,
    DetailList,
    TcgTable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      // 抽屉加载
      loading: false,
      viewDetailData: {},
      // 字典
      dict: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        bill_id: this.id,
        cname: ''
      },
      queryParam1: {
        bill_id: this.id,
        cname: ''
      },
      // 表头
      columns: [
        {
          title: '订单ID',
          dataIndex: 'order_id'
        },
        {
          title: '旺旺名',
          dataIndex: 'uaccount'
        },
        {
          title: '日期',
          dataIndex: 'create_time'
        },
        {
          title: '课程名称',
          dataIndex: 'cname'
        },
        {
          title: '购买数量',
          dataIndex: 'paynum'
        },
        // {
        //   title: '老师',
        //   dataIndex: 'tname'
        // },
        // {
        //   title: '学生',
        //   dataIndex: 'uname'
        // },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '奖金',
          dataIndex: 'award_money'
        }
      ],
      // 表头
      columns1: [
        {
          title: '课程ID',
          dataIndex: 'sub_id',
          width: '100px'
        },
        {
          title: '旺旺名',
          dataIndex: 'uname'
        },
        {
          title: '日期',
          dataIndex: 'days'
        },
        {
          title: '时间',
          dataIndex: 'times'
        },
        {
          title: '课程名称',
          dataIndex: 'cname'
        },
        // {
        //   title: '老师',
        //   dataIndex: 'tname'
        // },
        // {
        //   title: '学生',
        //   dataIndex: 'uname'
        // },
        {
          title: '评分',
          dataIndex: 'teacher_point'
        },
        {
          title: '评价',
          dataIndex: 'evaluate'
        },
        {
          title: '工资系数',
          dataIndex: 'wage_ratio'
        },
        {
          title: '工资',
          dataIndex: 'course_money'
        },
        {
          title: '延时扣款',
          dataIndex: 'late_deduct_money'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return orderList(Object.assign(parameter, this.queryParam))
          .then(res => {
            this.awardMoney = _.get(res, 'values.award_money', 0.00)
            return res
          })
      },
      // 加载数据方法 必须为 Promise 对象
      loadData1: parameter => {
        return subscribeList(Object.assign(parameter, this.queryParam))
          .then(res => {
            this.courseMoney = _.get(res, 'values.course_money', 0.00)
            this.deductMoney = _.get(res, 'values.deduct_money', 0.00)
            return res
          })
      },
      awardMoney: 0.00,
      courseMoney: 0.00,
      deductMoney: 0.00
    }
  },
  methods: {
    // 关闭抽屉
    onClose () {
      this.$emit('hide')
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.orderTable.refresh(true)
    },
    // 提交筛选
    handleSubmit1 (e) {
      e.preventDefault()
      this.$refs.subTable.refresh(true)
    },
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict = _.get(res, 'values', {})
        }
      })
    },
    // 加载数据详情
    getDetail () {
      this.loading = true
      getDetail(this.id).then(res => {
        if (_.get(res, 'code') === 200) {
          this.viewDetailData = _.get(res, 'data', {})
          this.loading = false
        }
      })
    }
  },
  created () {
    this.handelPre()
    this.getDetail()
  }
}
</script>
